{
  "app": {
    "name": "Beyond Silence",
    "tagline": "Un journalisme qui brise le silence"
  },
  "nav": {
    "home": "Accueil",
    "articles": "Articles",
    "about": "À propos",
    "donate": "Faire un don",
    "language": "Langue",
    "menu": "Menu",
    "close": "Fermer",
    "search": "Rechercher"
  },
  "search": {
    "placeholder": "Rechercher des articles…",
    "submit": "Rechercher",
    "clear": "Effacer la recherche",
    "inputLabel": "Rechercher des articles"
  },
  "actions": {
    "readMore": "Lire la suite",
    "share": "Partager",
    "backToHome": "Retour à l'accueil",
    "loadMore": "Voir plus"
  },
  "states": {
    "loading": "Chargement…",
    "error": "Une erreur s'est produite",
    "empty": "Rien à afficher pour le moment",
    "notFound": "Page introuvable",
    "unauthorized": "Vous n'avez pas accès à cette page",
    "articleNotFound": "L'article que vous cherchez n'existe pas ou a été supprimé."
  },
  "footer": {
    "copyright": "© {{year}} Beyond Silence. Tous droits réservés.",
    "legalNotice": "Mentions légales",
    "privacy": "Politique de confidentialité",
    "terms": "Conditions d'utilisation",
    "contact": "Contact",
    "coffee": "Offrez-nous un café",
    "builtBy": "Site réalisé par"
  },
  "legal": {
    "legalNotice": {
      "title": "Mentions légales",
      "sections": [
        {
          "h": "Éditeur du site",
          "b": "Beyond Silence, plateforme de journalisme trilingue (français, anglais, arabe), éditée par l'équipe Beyond Silence."
        },
        {
          "h": "Réalisation",
          "b": "Webnova — 60 Rue François Ier, 75008 Paris, France. SIRET : 941 713 125 00016."
        },
        {
          "h": "Hébergement",
          "b": "Le site est hébergé par Cloudflare (Cloudflare Pages). Pour toute question relative à l'hébergement, veuillez contacter l'éditeur."
        },
        {
          "h": "Propriété intellectuelle",
          "b": "L'ensemble du contenu de ce site (textes, images, graphismes, logo, vidéos) est la propriété exclusive de Beyond Silence et de ses contributeurs. Toute reproduction, même partielle, est interdite sans accord préalable écrit."
        },
        {
          "h": "Responsabilité",
          "b": "Beyond Silence s'efforce d'assurer l'exactitude des informations diffusées sur ce site, mais ne peut garantir leur exhaustivité. L'éditeur décline toute responsabilité pour tout dommage résultant de l'utilisation du site."
        },
        {
          "h": "Contact",
          "b": "Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter via la page contact du site ou par e-mail à contact@beyondsilence.fr."
        }
      ]
    },
    "privacy": {
      "title": "Politique de confidentialité",
      "sections": [
        {
          "h": "1. Informations que nous collectons",
          "b": "Nous collectons uniquement les informations nécessaires au fonctionnement de Beyond Silence : des données techniques telles que le type de navigateur et les pages consultées, et — si vous faites un don — les informations de paiement traitées par notre prestataire de paiement. Nous ne voyons ni ne conservons jamais votre numéro de carte complet."
        },
        {
          "h": "2. Utilisation de vos informations",
          "b": "Nous utilisons ces informations pour faire fonctionner et améliorer le site, traiter les dons et respecter nos obligations légales. Les analyses sont agrégées et anonymisées ; nous utilisons des identifiants de session respectueux de la vie privée, jamais d'adresses IP brutes, d'adresses e-mail ou d'autres identifiants personnels stables."
        },
        {
          "h": "3. Cookies et suivi",
          "b": "Nous n'utilisons pas de cookies publicitaires ni de suivi publicitaire. Les cookies éventuels sont strictement nécessaires au fonctionnement du site et à vos préférences linguistiques."
        },
        {
          "h": "4. Partage de vos informations",
          "b": "Nous ne vendons jamais vos informations personnelles. Elles ne sont partagées qu'avec des prestataires de confiance (hébergement, base de données, paiement) dans la mesure nécessaire au service, ou lorsque la loi l'exige."
        },
        {
          "h": "5. Conservation et vos droits",
          "b": "Nous ne conservons les données personnelles que le temps nécessaire. Vous pouvez à tout moment demander l'accès, la rectification ou la suppression de vos données en nous contactant."
        }
      ]
    },
    "terms": {
      "title": "Conditions d'utilisation",
      "sections": [
        {
          "h": "1. Acceptation",
          "b": "En utilisant beyondsilence.fr, vous acceptez les présentes conditions. Si vous n'êtes pas d'accord, veuillez ne pas utiliser le site."
        },
        {
          "h": "2. Contenu et propriété intellectuelle",
          "b": "Tous les articles, images et vidéos de ce site appartiennent à Beyond Silence et à ses contributeurs, sauf mention contraire. Vous pouvez partager des liens et de courtes citations avec mention de la source, mais pas reproduire notre contenu à des fins commerciales sans autorisation."
        },
        {
          "h": "3. Dons",
          "b": "Les dons sont des contributions volontaires traitées de manière sécurisée par notre prestataire de paiement. Ils ne constituent pas un achat et ne créent ni abonnement ni droit d'accès."
        },
        {
          "h": "4. Utilisation acceptable",
          "b": "Vous vous engagez à ne pas détourner le site, à ne pas perturber son fonctionnement et à ne pas tenter d'accéder à des systèmes ou données restreints."
        },
        {
          "h": "5. Avertissements et responsabilité",
          "b": "Le journalisme est fourni à titre d'information générale. Malgré notre exigence d'exactitude, nous ne garantissons ni l'exhaustivité ni l'actualité et déclinons toute responsabilité liée à l'usage de nos contenus."
        },
        {
          "h": "6. Modifications et contact",
          "b": "Nous pouvons mettre à jour ces conditions. L'utilisation continue du site vaut acceptation. Des questions ? Contactez-nous à contact@beyondsilence.fr."
        }
      ]
    }
  }
}
